module.exports = __webpack_public_path__ + "img/contact-johandalen.07aa54f2.png";